import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstallService } from '../../../services/install.service';

@Component({
  selector: 'app-pwa-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (installService.shouldShowBanner) {
    <div class="pwa-install-banner">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-white rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
          <img src="/rcma-logo.png" alt="RCMA" class="w-7 h-7 object-contain">
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-white font-bold text-sm">Install RCMA CAD App</div>
          @if (installService.isIos) {
            <div class="text-red-200 text-xs mt-0.5">Tap <i class="fas fa-arrow-up-from-bracket mx-0.5"></i> Share below, then <strong>"Add to Home Screen"</strong> <i class="fas fa-plus-square mx-0.5"></i></div>
          } @else {
            <div class="text-red-200 text-xs">Get push alerts and quick access</div>
          }
        </div>
        @if (!installService.isIos) {
          <button (click)="installApp()" class="bg-white text-red-700 font-black px-4 py-2 rounded-lg text-sm hover:bg-red-50 flex-shrink-0"><i class="fas fa-download mr-1"></i>Install</button>
        }
        <button (click)="dismiss()" class="text-red-200 hover:text-white w-10 h-10 flex items-center justify-center rounded-lg hover:bg-red-800/50 flex-shrink-0"><i class="fas fa-times"></i></button>
      </div>
    </div>
    }
  `
})
export class PwaBannerComponent {
  constructor(public installService: InstallService) {}

  installApp(): void {
    this.installService.promptInstall();
  }

  dismiss(): void {
    this.installService.dismiss();
  }
}
